import { useLocales as UseLocales } from '@/locales';
import {
  Award,
  Code2,
  FileSearch,
  FileText,
  Grid3x3,
  HelpCircle,
  ListOrdered,
  MapPin,
} from 'lucide-react';

const menuItems = () => {
  const { translate } = UseLocales();
  return [
    {
      menu: translate('Custom_clearance'),
      label: 'submissions',
      icon: <FileText />,
    },
    {
      menu: translate('Certicate_cargo'),
      //menu: translate("Definition_of_certification_body"),
      label: 'certification',
      icon: <Award />,
    },
    // {
    //   menu: translate('Online_support'),
    //   label: 'support',
    //   icon: <Headphones />,
    // },
    {
      menu: translate('Definition_TNVD'),
      label: 'codes',
      icon: <Code2 />,
    },
    { menu: translate('Sample_doc'), label: false, icon: <FileSearch /> },
    {
      menu: translate('Adress_post'),
      label: 'post_office',
      icon: <MapPin />,
    },
    {
      menu: translate('Sample_doc'),
      label: 'docExapmles',
      icon: <Grid3x3 />,
    },
    {
      menu: translate('directories'),
      label: 'wrapper',
      icon: <ListOrdered />,
      children: [
        {
          menu: translate('directories'),
          label: 'directory',
          // icon: <AllInclusiveOutlined />,
        },
        {
          menu: translate('Calculator'),
          label: 'calc',

          // icon: <AllInclusiveOutlined />,
        },
        {
          menu: translate('Classifier_of_customs_posts'),
          label: 'pcode',
          // icon: <Inventory2Sharp />,
        },
        {
          menu: translate('Account_information'),
          label: 'facture',
          // icon: <AccountBalance />,
        },
      ],
      // icon: <Clock />,
    },
    {
      menu: `${translate('Help')} (FAQ)`,
      label: 'faq',
      icon: <HelpCircle />,
    },
  ];
};

export default menuItems;
